import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { defineComponent, ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { mapState, useStore } from "vuex";
import {
  archiveOutline,
  archiveSharp,
  bookmarkOutline,
  bookmarkSharp,
  heartOutline,
  heartSharp,
  mailOutline,
  mailSharp,
  paperPlaneOutline,
  paperPlaneSharp,
  trashOutline,
  trashSharp,
  warningOutline,
  warningSharp,
} from "ionicons/icons";
import { routes } from "@/router";
import { handleUrlSessionLogin } from "@/state/authState";
import PWAPrompt from "@/components/shared/PWAPrompt.vue";


export default /*#__PURE__*/_defineComponent({
  name: 'App',
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();
const userProfile = () => store.state.userProfile;
const selectedIndex = ref(0);
const appReady = ref(false);
const appPages = routes
  .filter(route => !!route.meta?.menubar)
  .map(route => ({
    title: route.meta?.name,
    url: route.path,
    iosIcon: route.meta?.iosIcon,
    mdIcon: route.meta?.mdIcon,
  }));

console.log({ appPages });
selectedIndex.value = appPages.findIndex(
  page => page.url === router.currentRoute.value.path
);

onMounted(() => {
  // if (!window.location.hash) {
  //   appReady.value = true;
  //   router.push("/workouts");
  //   return;
  // }

  appReady.value = true;

  // const hashParams = new URLSearchParams(
  //   window.location.hash.substr(1, window.location.hash.length)
  // );
  //
  // if (hashParams.has("type")) {
  //   switch (hashParams.get("type")) {
  //     case "magiclink":
  //       handleUrlSessionLogin().then(() => {
  //         appReady.value = true;
  //         router.push("/workouts");
  //       });
  //       break;
  //     case "invite":
  //     case "recovery":
  //       handleUrlSessionLogin().then(() => {
  //         appReady.value = true;
  //         router.push("/reset-password");
  //       });
  //       break;
  //     case "signup":
  //       appReady.value = true;
  //       router.push("/workouts");
  //       break;
  //   }
  // } else {
  //   appReady.value = true;
  //   router.push("/workouts");
  // }
});

return (_ctx: any,_cache: any) => {
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_IonSplitPane = _resolveComponent("IonSplitPane")!
  const _component_IonApp = _resolveComponent("IonApp")!
  const _component_ion_loading = _resolveComponent("ion-loading")!

  return (appReady.value)
    ? (_openBlock(), _createBlock(_component_IonApp, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(PWAPrompt),
          _createVNode(_component_IonSplitPane, { "content-id": "main-content" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_router_outlet, { id: "main-content" })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(_component_ion_loading, {
        key: 1,
        "is-open": appReady.value,
        "css-class": "my-custom-class",
        message: "Please wait...",
        duration: 0
      }, null, 8, ["is-open"]))
}
}

})